import { SectionContainer } from '@/components/v2/atoms/section-container/section-container'
import { NotFoundHero } from '@/components/v2/unique/not-found/not-found-hero/not-found-hero'
import { Component, ReactNode } from 'react'

class ErrorBoundary extends Component<
  { children: ReactNode },
  { hasError: boolean }
> {
  constructor(props: any) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      return (
        <SectionContainer>
          <NotFoundHero errorCode="500" />
        </SectionContainer>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
